import {Component, OnInit, ViewChild, signal} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddMasterProductComponent } from './add-master-product/add-master-product.component';
import { DeleteMasterProductComponent } from './delete-master-product/delete-master-product.component';
import { MasterdataService } from '../../services/masterdata.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BASE_URL } from '../../../config/config';
import { MessagePopupComponent } from '../../bulk-upload/modals/message-popup/message-popup.component';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-products',
  standalone: true,
  imports: [CommonModule,FormsModule,PaginationComponent],
  templateUrl: './master-products.component.html',
  styleUrls: ['./master-products.component.scss', '../../../app.component.scss']
})

export class MasterProductsComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  totalProductsCount: number = 0;
  public alerts: any = []
  public delete: any = []
  public masterType: string = "products";
  public fileType = "";
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  searchTerm: string = '';
  public statusMessage: string = "";
  public products: any = [] 
  public isDragOver = signal(false);
  public bodyparts: any = [];
  public implants: any ;
  public category: any;
  public images: any;
  public image: any;
  private productId: string = '74656';

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  public paginationData: any;
  public currentPage: number = 1;
  public id : any;

  public search : any = [];
 
  public selectedStatus = [];

  public BASE = BASE_URL.URL;

  constructor(private spinnerService: NgxSpinnerService,public dialog: MatDialog, public masterdataService: MasterdataService, public router: Router) { }

  ngOnInit(): void {
    this.getMasterProducts(this.search,this.currentPage);
    this.getMasterBodyParts();
    this.getMasterImplants();
    this.getMasterProductCategory();
    // this.getImageUrl(this.id);
  }

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }
    
    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput: any = document.getElementById("masterproductwrapper").querySelector('[id="file-input"]');
    if (fileInput) fileInput.click();
  }
  
  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes: string[] = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.fileType = ext;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  onSubmit() {
    this.spinnerService.show(); 
    let formData = new FormData();
    
    formData.append('file', this.uploadedFile);
    let loggedUser = JSON.parse(localStorage.getItem('role'));
    formData.append('warehouse_id', loggedUser.resource_id);

    let token = localStorage.getItem('token');

    fetch(`${this.BASE}/bulk-stocks/master/upload/${this.masterType}`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response)=>{
      if (response.status === 200) {
        if (response.headers.get('Content-Type') === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const uploadeEntries = response.headers.get('Uploaded-Entries');
          const invalidEntries = response.headers.get('Invalid-Entries');
          let fileName = `${this.masterType}-${this.fileType}-error`;
          return response.blob().then((blobContent) => {
            this.getMasterProducts(this.search,this.currentPage);
            this.openDialogBrowse(blobContent, uploadeEntries, invalidEntries, fileName);
          })
        }else if(response.headers.get('Content-Type') === "application/json"){
          this.statusType = 'success';
          this.statusMessage = `The ${this.uploadedFile.name} data has been uploaded successfully!`;
          this.showWarningToast();
          this.getMasterProducts(this.search,this.currentPage);
        }
      }

      if (response.status === 204) {
        this.statusType = 'success';
        this.statusMessage = 'Nothing to update';
        this.showWarningToast();
      }

      if (response.status === 422) {
        this.statusType = 'error';
        this.statusMessage = 'Unprocessable Content';
        this.showWarningToast();
        
        response.json().then((jsonData) =>{
          if (!jsonData.data.excluded) {
            this.statusType = 'error';
            this.statusMessage = 'Error: The uploaded file and uploaded for doesn’t match';
            this.showWarningToast();
          }
        })
      }

      if (response.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.spinnerService.hide();
        return;
      }

      if (response.status === 500) {
        this.statusType = 'error';
        this.statusMessage = `Oops, Something went wrong!`;
        this.showWarningToast();
      }
    })
    .catch((err)=>{
      this.spinnerService.hide();
      console.log('err', err);
    }).finally(()=>{
      this.spinnerService.hide();
    })
  }
  
  resetFile(){
    this.isFile = false;
    this.fileType = '';
  }

  openDialogBrowse(blob, uploadeEntries: string, invalidEntries: string, fileName: string): void {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      data: {
        blob,
        uploadeEntries, 
        invalidEntries,
        fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    if (toastContainer) {
      setTimeout(function() {
        toastContainer.classList.add('show');
      }, 100);
      setTimeout(function() {
        toastContainer.classList.remove('show');
      }, 5000);
    }
  }

  downloadBulkUploadTemplate(products) {
    this.masterdataService.downloadBulkUploadTemplate(products);
  }

  openEditDialog(products:any): void { 

    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      disableClose: true,
      data: {
        type: "edit",
        item: products,
        bodyparts: this.bodyparts,
        implants: this.implants,
        categories: this.category, 
      }
    }).afterClosed().subscribe(()=>{
      this.getMasterProducts(this.search, this.currentPage);
    });
  }

  openDialog(products): void {
    this.getMasterBodyParts();
    this.getMasterImplants(); 
    this.getMasterProductCategory();
    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      disableClose: true,
      data:{
        type: "add",
        bodyparts: this.bodyparts,
        implants: this.implants,
        categories: this.category,
      }
    });
    dialogRef.afterClosed().subscribe(()=>{
      this.getMasterProducts(this.search,this.currentPage);
    });
  } 

  getMasterBodyParts(){
    this.masterdataService.getMasterBodyParts(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        this.bodyparts = res.data.data.map(item => {return {id:item.id, value:item.name}});
      }
    });
  }

  getMasterImplants(){
    this.masterdataService.getMasterImplants(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        this.implants = res.data.data.map(item => {return {id:item.id, value:item.name}});
      }
    });
  } 

  getMasterProductCategory(){
    this.masterdataService.getMasterProductCategory(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        console.log("masterproduct",)
        this.category = res.data.data.map(item => {return {id:item.id, value:item.name }});
      }
    });
  }

  openDeleteDialog(item: any): void {
    const dialogRef = this.dialog.open(DeleteMasterProductComponent, {
    }).afterClosed().subscribe(result=>{
      if(result == "confirm"){
        this.masterdataService.deleteBodyParts(item.id, "products").subscribe((res:any)=>{
          if(res && res.success){
            this.getMasterBodyParts();
            this.getMasterImplants();
            this.getMasterProductCategory();
            this.getMasterProducts(this.search, this.currentPage);
          }
        })
      } 
    });
  }

  getMasterProducts(search: string = "", currentPage: number){
    this.masterdataService.getMasterProducts(search, currentPage).subscribe((res)=>{
      if (res.data) {
        this.products = res.data.data;
        this.paginationData = res.data.data;
        this.totalProductsCount =  res.data.total;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
        console.log(this.paginationData, " paginationData");
      }
    });
  } 

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getMasterProducts(this.search,this.currentPage)
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getMasterProducts(this.encodedSearchInput, this.currentPage);
    }
  }

  searchByProductsName(): void {
    this.products = this.products.filter((products: any) =>
      products.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.getMasterProducts(this.search,this.currentPage);
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getMasterProducts(this.search,this.currentPage);
    }
  }

  // getMasterImages(id: string): void {
  //   this.masterdataService.getMasterImages(id).subscribe((res) => {
  //     if (res.data) {
  //       this.images = res.data; // Assuming res.data is the array of images
  //     }
  //   });
  // }

  // getImageUrl(id: string): string {
  //   return `${this.BASE}/files/products/${id}`;
  // }

  getImageUrl(imageName: string): string {
    if (imageName) {
      // Adjust the base URL if necessary to match where your images are hosted
       return BASE_URL.API_URL + 'storage/products/' + imageName;
    }
    return '../../../../assets/images/hipSystem.svg'; // Fallback image
  }

  // getImageUrl(id: string){
  //   this.masterdataService.getMasterImages(id).subscribe((res)=>{
  //     if (res.data) {
  //       this.products = res.data.data;
  //       // Adjust the base URL if necessary to match where your images are hosted
  //       return `${this.BASE}/files/products/${id}`;
  //     }
  //     return '../../../../assets/images/hipSystem.svg'; 
  //   });
  // }

}
